// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3032":"5491f6662a430b76","6047":"439f25910690824a","8172":"63bcec687fadfad2"}[chunkId] + ".css";
};